import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import firebase from "@firebase/app";
import "@firebase/firestore";
import { FirestoreProvider } from "react-firestore";
import { BrowserRouter } from "react-router-dom";

const config = {
  apiKey: "AIzaSyDJnMh0qfcWN0YFQpSOIp3AytLDA_-m4Ac",
  projectId: "links-42d1a",
};

firebase.initializeApp(config);
window.firebase = firebase;

const firestore = firebase.firestore();
firestore.settings({ timestampsInSnapshots: false });

ReactDOM.render(
  <BrowserRouter>
    <FirestoreProvider firebase={firebase}>
      <App />
    </FirestoreProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js